<template>
  <div>
    <Breadcrumbs :classes="{ menu: true }"/>
    <div class="pb-4 col-sm-12">
      <h2 class="text-menu">オプションメニュー選択</h2>
      <h5 id="text-options-required" class="text-danger pb-2 font-family-W3">
        ※オプションメニューの選択は必須ではございません</h5>
    </div>
    <div class="timeprice-container">
      <div v-for="optionPair in filteredOptionPairs" :key="optionPair[0].id" class="timeprice-pair">
        <div class="container-fluid">
          <div class="row">
            <div v-for="option in optionPair" :key="option.id" class="timeprice-card col-md-6 col-xs-12">
              <div class="card card-timeprice">
                <div class="card-body h-100 margin-card-flex my-3">
                  <div class="text-content d-flex flex-wrap justify-content-start" @click="toggleCheckbox(option)">
                    <div class="col-sm-1 checkmark-wrapper my-3">
                      <input
                          class="custom-control-input checkmark-input input-flex-shrink"
                          :class="'active-timeprice-option' + option.id"
                          :data-id="option.id"
                          :data-name="option.name"
                          :data-unitprice="option.unitprice"
                          name="menu_option"
                          type="checkbox"
                          :checked="isChecked(option.id)"
                      >
                      <span class="checkmark-label"/>
                    </div>
                    <div class="col-sm-6 timeprice-option-booking my-3 break-words">
                      <span v-if="option.name" class="text-permalink-home font-hiraginoSans-w6 ">{{ option.name }}</span>
                    </div>
                    <div class="col-sm-2 my-3 p-0">
                      <div class="mr-3 text-permalink-home text-bold text-normal">
                        <span v-if="option.timeunit">{{ option.timeunit }}分</span>
                        <br v-else/>
                      </div>
                    </div>
                    <div class="col-sm-3 my-3 p-0">
                      <div class="text-permalink-home text-bold text-normal">
                        <span v-if="option.unitprice">{{ numberWithDelimiter(option.unitprice) }}円</span>
                        <span v-if="option.unitprice"> (税込)</span>
                        <br v-else/>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between">
                    <div class="img w-40">
                      <img
                           :src="option.timeprice_option_image.url" alt=""/>
                    </div>
                    <div
                        v-if="(option.timeprice_option_image && option.timeprice_option_image.url) || option.timeprice_option_explain"
                        class="show-modal-timeprice margin-top-auto margin-bottom-auto">
                      <a class="font-family-W3 cursor-timeprice" @click="showModal(option)">
                        オプションの詳細を見る
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="optionPair.length === 1" class="timeprice-card col-md-6 col-xs-12">
              <div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-wrapper py-5">
      <div class="container">
        <div class="footer-buttons d-flex">
          <span id="backStepChooseTimeprice" class="back-step mr-2" @click="goBack">戻る</span>
          <div class="btn-choose-timeprice-option next-step text-center scroll-top" @click="goNext">
            次に進む
          </div>
        </div>
      </div>
    </div>
    <Modal :show="showModalFlag" :option="selectedOption" @close="closeModal"/>
  </div>
</template>

<script>
import Breadcrumbs from './Breadcrumbs.vue';
import Modal from './Modal.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'ChooseTimePriceOption',
  components: {
    Breadcrumbs,
    Modal
  },
  data() {
    return {
      showModalFlag: false,
      selectedOption: {}
    };
  },
  computed: {
    ...mapGetters('permalink', ['timepriceOptions', 'selectedTimepriceOptions']),
    filteredOptionPairs() {
      const pairs = [];
      for (let i = 0; i < this.timepriceOptions.length; i += 2) {
        pairs.push(this.timepriceOptions.slice(i, i + 2));
      }
      return pairs;
    }
  },
  methods: {
    ...mapActions('permalink', ['setSelectedTimepriceOptions']),
    toggleCheckbox(option) {
      const index = this.selectedTimepriceOptions.findIndex(o => o.id === option.id);
      if (index > -1) {
        this.selectedTimepriceOptions.splice(index, 1);
      } else {
        this.selectedTimepriceOptions.push(option);
      }
      this.setSelectedTimepriceOptions(this.selectedTimepriceOptions);
    },
    isChecked(optionId) {
      return this.selectedTimepriceOptions.some(o => o.id === optionId);
    },
    goBack() {
      this.$emit('goBack');
    },
    goNext() {
      this.$emit('goNext', this.selectedTimepriceOptions);
    },
    showModal(option) {
      this.selectedOption = option;
      this.showModalFlag = true;
    },
    closeModal() {
      this.showModalFlag = false;
    },
    numberWithDelimiter(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  },
  mounted() {
    window.scrollTo(0,0);
  }
};
</script>

<style scoped>
.text-content {
  display: flex;
  justify-content: space-between;
}

.timeprice-option-booking {
  width: 20%;
  flex: 1;
}

.img {
  max-width: 100%;
}

.w-40 {
  width: 40%;
}

.img img {
  max-width: 100%;
  height: auto;
  max-height: 150px;
}

.show-modal-timeprice {
  align-self: center;
}

.btn-choose-timeprice-option {
  align-self: flex-end;
}

.break-words {
  word-break: break-word;
}

.custom-control-input {
  margin-right: 10px;
}

.cursor-timeprice {
  cursor: pointer;
}

.row {
  margin-left: -15px !important;
  margin-right: -15px !important;
}

@media (max-width: 768px) {
  .timeprice-option-booking {
    width: 80%;
    flex: auto;
  }
}
</style>
